var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      ref: "modal",
      staticClass: "identity-to-submit-full-screen-modal",
      attrs: {
        id: "identity-to-submit-modal",
        "header-class": "identity-to-submit-modal-header",
        centered: "",
        scrollable: "",
        "no-close-on-esc": _vm.noClose,
        "no-close-on-backdrop": _vm.noClose
      },
      scopedSlots: _vm._u([
        {
          key: "modal-header",
          fn: function(ref) {
            var close = ref.close
            return [
              _c(
                "div",
                {
                  staticClass:
                    "identity-to-submit-modal-header-content step4 w-100"
                },
                [
                  _c("img", {
                    staticClass: "identity-to-submit-modal-img",
                    attrs: {
                      src: require("@/assets/images/b122/ic_investigator_binoculars.png")
                    }
                  })
                ]
              )
            ]
          }
        },
        {
          key: "modal-footer",
          fn: function(ref) {
            var ok = ref.ok
            var cancel = ref.cancel
            var hide = ref.hide
            return [
              _c(
                "div",
                { staticClass: "w-100 d-flex" },
                [
                  _c(
                    "b-button",
                    {
                      staticClass: "w-100 mr-2",
                      attrs: { variant: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.handleOk($event)
                        }
                      }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "d-flex justify-content-center align-items-center"
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "align-self-center mt-small-px" },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("identity.to.submit.button"))
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c("i", {
                            staticClass:
                              "ph-custom ph-caret-circle-right-bold ml-3",
                            attrs: { size: "24" }
                          })
                        ]
                      )
                    ]
                  )
                ],
                1
              )
            ]
          }
        }
      ])
    },
    [
      _vm._v(" "),
      _c("div", [
        _c("div", { staticClass: "page-title mb-4" }, [
          _vm._v(
            "\n      " + _vm._s(_vm.$t("identity.to.submit.title")) + "\n    "
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "first-connexion-identity-info" }, [
          _c("span", [_vm._v(_vm._s(_vm.$t("validate_identity_info_1")))]),
          _vm._v(" "),
          _c(
            "span",
            { staticClass: "first-connexion-identity-info-highlight" },
            [_vm._v(_vm._s(_vm.$t("validate_identity_info_2")))]
          )
        ]),
        _vm._v(" "),
        _c("p", {
          staticClass: "modal-annonce-text mt-2",
          domProps: {
            innerHTML: _vm._s(_vm.$t("identity.to.submit.details.part1"))
          }
        }),
        _vm._v(" "),
        _c("p", {
          staticClass: "modal-annonce-text",
          domProps: {
            innerHTML: _vm._s(_vm.$t("identity.to.submit.details.part2"))
          }
        })
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-932893dc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-932893dc","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/user/IdentityToSubmitModal.vue
// module id = xqYU
// module chunks = 0